// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1dVTQ","calendarButtons":"ClockData_calendarButtons__2h37M"};